import * as React from "react";
const SvgFullscreen = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 10h-2V2H6V0h10v10zm-6 6H0V6h2v8h8v2z", fill: "white" }));
export default SvgFullscreen;
